import { DateTime } from 'scaleflow/utils/date-time';

export default function (date) {
  return DateTime.from(date).fromNow();
}
